import { render, staticRenderFns } from "./VMenuItem.vue?vue&type=template&id=c1842244&scoped=true&functional=true"
import script from "./VMenuItem.vue?vue&type=script&lang=js"
export * from "./VMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VMenuItem.vue?vue&type=style&index=0&id=c1842244&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c1842244",
  null
  
)

export default component.exports